import { MarketSlug } from '../../common/CountryMarketConfig';
import { ModificationTypes, StepsByBranch } from '../../types';
import { getStepsForModifyFlowForHCIC } from './marketSpecificHooks/homecareIndustrialCleaning';

export { Briefing } from './Briefing';

// This is a function, rather than just an object, so that we can easily
// have the same steps for different markets by adding those markets as
// an additional case. This wouldn't be possible with an object.
export const getStepsByBranchByMarket = (
  marketSegment?: MarketSlug | string,
  modificationType?: ModificationTypes | null,
): StepsByBranch => {
  switch (marketSegment) {
    case MarketSlug.FoodNutrition:
      return {
        create: [
          'application',
          'formulation-attributes',
          'processing-capabilities',
          'price',
          'additional-info',
          'review',
        ],
        modify: [],
        enhance: [
          'application',
          'problem',
          'formulation-attributes',
          'processing-capabilities',
          'ingredients',
          'additional-info',
          'review',
        ],
        fix: [
          'problem',
          'application',
          'processing-capabilities',
          'ingredients',
          'additional-info',
          'review',
        ],
      };
    case MarketSlug.HomeCareIndustrialCleaning:
      return {
        create: [
          'application',
          'formulation-attributes',
          'requirements',
          'colour',
          'fragrance',
          'price',
          'product-details',
          'additional-info',
          'review',
        ],
        enhance: [],
        // The steps array for the HCIC modify flow is conditional,
        // but must start with 'modification-type' step so the
        // user can select the type to then render the particular steps
        modify: modificationType
          ? getStepsForModifyFlowForHCIC(modificationType)
          : ['modification-type'],
        fix: [
          'application',
          'problem',
          'ingredients',
          'price',
          'product-details',
          'additional-info',
          'review',
        ],
      };
    case MarketSlug.AgriEnvironmental:
      return {
        create: [
          'application',
          'active-ingredients',
          'active-function',
          'additional-info',
          'review',
        ],
        modify: [],
        enhance: [
          'application',
          'active-ingredients',
          'ingredients',
          'additional-info',
          'review',
        ],
        fix: [
          'problem',
          'application',
          'active-ingredients',
          'ingredients',
          'additional-info',
          'review',
        ],
      };
    case MarketSlug.PersonalCare:
    default:
      return {
        create: [
          'application',
          'target-consumer',
          'formulation-attributes',
          'packaging',
          'restrictions',
          'price',
          'additional-info',
          'review',
        ],
        modify: [],
        enhance: [
          'application',
          'problem',
          'formulation-attributes',
          'packaging',
          'restrictions',
          'ingredients',
          'additional-info',
          'review',
        ],
        fix: [
          'problem',
          'application',
          'ingredients',
          'additional-info',
          'review',
        ],
      };
  }
};
